import React, { useEffect } from "react";
import { useQueryClient } from "react-query";

import styles from "./index.module.scss";

interface Props {
  close: () => void;
}

const PendingPaymentCard: React.FC<Props> = ({ close }) => {
  const queryClient = useQueryClient();
  useEffect(() => {
    setTimeout(() => {
      queryClient.invalidateQueries(["user"]);
      close();
    }, 3000);
  }, []);

  return (
    <div className={styles.modalContainer}>
      Traitement en cours… Merci de bien vouloir patienter
    </div>
  );
};

export default PendingPaymentCard;
